import intlTelInput from "intl-tel-input";

const LANG_TO_COUNTRY = { nb: "no", nn: "no", sv: "se", da: "dk", en: "us" };

function detectCountry() {
  const langs = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  for (const tag of langs) {
    const [lang, region] = tag.split("-");
    if (region && region.length === 2) return region.toLowerCase();
    const mapped = LANG_TO_COUNTRY[lang.toLowerCase()];
    if (mapped) return mapped;
  }
  return "no";
}

export default function registerPhoneInput(Alpine) {
  Alpine.data("phoneInput", () => ({
    iti: null,
    init() {
      const input = this.$refs.input;
      if (!input || input.dataset.itiInitialized === "1") return;
      input.dataset.itiInitialized = "1";

      this.iti = intlTelInput(input, {
        initialCountry: detectCountry(),
        formatAsYouType: true,
        hiddenInputs: (telInputName) => ({ phone: telInputName }),
        loadUtils: () => import("intl-tel-input/utils"),
        // The library's default label puts the visible dial code in
        // parentheses at the end. Label-in-name checks (WCAG 2.5.3) skip
        // parenthesised text, so lead with the dial code instead.
        uiTranslations: input.dataset.countryLabel ? { selectedCountryAriaLabel: input.dataset.countryLabel } : {}
      });
    }
  }));
}
